module.exports = __webpack_public_path__ + "img/pertanian.ce116da.png";